import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the FilterDepositReportsView.
 * @extends JetView
 */
export default class FilterDepositReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a1',
            autoheight: true,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for date range
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker', // Datepicker component
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Limit to today's date
                                },
                            },
                        },
                        {
                            view: 'text', // Text input for transaction ID
                            name: 'TransactionId',
                            type: 'number',
                            label: _('Transacción ID'),
                            labelPosition: 'top',
                            placeholder: _('Transacción ID'),
                            invalidMessage: _('Transacción ID is required'), // Validation message
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Contains the left section with inputs
                },
            ],
        };
        const buttons = {
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('depositReportAgent:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Clear button for popup
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').clear(); // Clears the popup form
                    },
                },
                {
                    view: 'button', // Consult button for popup
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get popup form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if typeDate is not 2
                        } else {
                            if (profile.typeDate == 2) {
                                delete filterdata['Datepicker']; // Remove datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('depositReportAgent:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                        $$('filterPopup').hide(); // Hide the popup after consultation
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Contains upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Contains upper section
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Popup title
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Contains scrollable section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm', // Main form ID
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if typeDate is not 2
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date input if typeDate is 2
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal configuration
        });
    }
}

// FILE DOCUMENTED
